import React, { useState } from "react";
import { Link } from "gatsby";
import Modal from "../Modal";
import Tick from "../../images/svgs/animated-tick.svg";

const CheckoutButtons = ({
  subscription,
  context,
  inStock,
  productVariant,
  quantity,
  checkoutLink,
  product,
}) => {
  const [modal, setModal] = useState(false);

  const showModal = () => {
    setModal(true);
  };

  const hideModal = () => {
    setModal(false);
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    context.addVariantToCart(productVariant.shopifyId, quantity);
    showModal();
  };

  const handleAddToCart_BuyNow = (e) => {
    e.preventDefault();
    context.addVariantToCartAndBuyNow(productVariant.shopifyId, quantity);
    window.location.replace(checkoutLink);
  };

  return (
    <>
      <Modal visible={modal} toggle={setModal} timeout={7000}>
        <Tick className="w-24 h-24 mx-auto" />
        <h2>Success!</h2>
        <p>We've added {product} to your cart</p>
        <div className="flex">
          <div className="w-1/2 pr-2">
            <Link to="/cart">
              <button className="border border-green text-green w-full p-2">
                View Cart
              </button>
            </Link>
          </div>
          <div className="w-1/2 pl-2">
            <button
              className="bg-green border border-green text-white w-full p-2 hover:bg-green-dark"
              onClick={hideModal}
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </Modal>
      {!subscription && (
        <div className="flex">
          <div className="w-1/2 pr-2">
            <button
              className="border border-green text-green w-full p-2"
              disabled={!inStock}
              onClick={handleAddToCart}
            >
              Add to Cart
            </button>
          </div>
          <div className="w-1/2 pl-2">
            <button
              className="bg-green border border-green text-white w-full p-2 hover:bg-green-dark"
              disabled={!inStock}
              onClick={handleAddToCart_BuyNow}
            >
              Buy It Now
            </button>
          </div>
        </div>
      )}

      {subscription && (
        <button
          className="bg-green border border-green text-white px-8 py-2 mx-auto block hover:bg-green-dark"
          disabled={!inStock}
          onClick={handleAddToCart_BuyNow}
        >
          Complete Subscription
        </button>
      )}
    </>
  );
};

export default CheckoutButtons;
